import { lineFont } from '../state';

import { arrow } from './arrow';
import { circle } from './circle';

export function numLineDrawing(
  ctx: CanvasRenderingContext2D,
  t: string,
  col = 'magenta'
): void {
  const radius = 6;
  const xOffset = radius * 2 + 20;
  const yOffset = 10;
  const lineLength = 40;

  ctx.save();
  col = col || 'magenta';
  const tran = col === 'magenta' ? 1 : 0.85;

  ctx.globalAlpha = ctx.globalAlpha ?? tran;
  ctx.strokeStyle = col;
  ctx.lineWidth = 3;

  if (t === 'NL_OPTIONS') {
    // move to center of open-space of button (horizontally)
    ctx.translate(75, 16);
    ctx.font = 'bold 14px ' + lineFont;
    ctx.fillStyle = 'gray';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText('Number Line Options', 0, 0);
  } else if (t === 'X-->' || t === 'O-->') {
    const o = t === 'O-->';

    circle(ctx, xOffset, yOffset, o ? 5 : 6.5, col, o, true, 3);
    ctx.beginPath();
    ctx.moveTo(xOffset + radius, yOffset);
    ctx.lineTo(xOffset + lineLength, yOffset);
    arrow(ctx, xOffset, yOffset, xOffset + lineLength, yOffset, 'smaller');
    ctx.stroke();
  } else if (t === '<--O' || t === '<--X') {
    const o = t === '<--O';

    ctx.translate(2, 0);
    circle(
      ctx,
      xOffset + lineLength - radius,
      yOffset,
      o ? 5 : 6.5,
      col,
      o,
      true,
      3
    );
    ctx.beginPath();
    ctx.moveTo(xOffset - radius, yOffset);
    ctx.lineTo(xOffset + lineLength - 2 * radius, yOffset);
    arrow(ctx, xOffset, yOffset, xOffset - radius, yOffset, 'smaller');
    ctx.stroke();
  } else if (t.substring(1, 3) === '--') {
    const o1 = t.substring(0, 1) === 'O';
    const o2 = t.substring(3) === 'O';
    const segmentLength = 1.3 * lineLength;
    const xOffsetSegment = xOffset - 10;

    circle(ctx, xOffsetSegment, yOffset, o1 ? 5 : 6.5, col, o1, true, 3);
    circle(
      ctx,
      xOffsetSegment + segmentLength,
      yOffset,
      o2 ? 5 : 6.5,
      col,
      o2,
      true,
      3
    );
    ctx.beginPath();
    ctx.moveTo(xOffsetSegment + radius, yOffset);
    ctx.lineTo(xOffsetSegment + segmentLength - radius, yOffset);
    ctx.stroke();
  } else {
    // arrows going out from the circles
    const o1 = t.substring(1, 2) === 'O';
    const o2 = t.substring(2, 3) === 'O';
    const rayLength = 30;
    let xOffsetRays = xOffset - 20;

    // left ray
    circle(
      ctx,
      xOffsetRays + rayLength - radius,
      yOffset,
      o1 ? 5 : 6.5,
      col,
      o1,
      true,
      3
    );
    ctx.beginPath();
    ctx.moveTo(xOffsetRays - radius, yOffset);
    ctx.lineTo(xOffsetRays + rayLength - 2 * radius, yOffset);
    arrow(ctx, xOffsetRays, yOffset, xOffsetRays - radius, yOffset, 'smaller');
    ctx.stroke();

    // adjust xOffsetRays for ray to the right of the left ray
    xOffsetRays = xOffsetRays + rayLength + 2 * radius + xOffsetRays;

    // right ray
    circle(ctx, xOffsetRays, yOffset, o2 ? 5 : 6.5, col, o2, true, 3);
    ctx.beginPath();
    ctx.moveTo(xOffsetRays + radius, yOffset);
    ctx.lineTo(xOffsetRays + rayLength, yOffset);
    arrow(
      ctx,
      xOffsetRays,
      yOffset,
      xOffsetRays + rayLength,
      yOffset,
      'smaller'
    );
    ctx.stroke();
  }

  ctx.restore();
}
